module.exports = __webpack_public_path__ + "img/beb_1.71de2d31.gif";